import React, { useEffect, useState } from 'react';

type Props = {
    mailFolders: any[];
    createFolder: Function;
    closePopup: Function
};
const CreateFolderPopup = (props: Props) => {

    const [newFolderName, setNewFolderName] = useState<string>('')

    const closePopup = () => {
        props.closePopup();
    }
    
    const createFolder = () => {
        props.createFolder(newFolderName);
    }

    const onFolderNameChange = (folderName: string) => {
        console.log(folderName);
        setNewFolderName(folderName)
    }

    return (
    <div className="popup-wrapper">
        <section className="popup-window one-input move-to-folder rtl">
        <div className="close-icon pointer" onClick={(e:any)=>closePopup()}>
            <div className="popup-title"></div>
        </div>
        <div className="popup-content">
            <div className="popup-header">
                תיקיה חדשה
            </div>
            <div className="popup-body">
                <div className="parameter-row">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                שם תיקיה חדשה
                            </div>
                            <div className="value">
                                <input type='text' onChange={(e:any)=>onFolderNameChange(e.target.value)} />
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
            <div className="popup-footer">
                <button className="button blue" onClick={(e:any)=>createFolder()}>
                    אישור
                </button>
            </div>
        </div>
        </section>
    </div>
    )

}
export default CreateFolderPopup;